import React from 'react';
import Typewriter from 'typewriter-effect';
import 'tachyons';

const Quote = () => {
    return (
        <div className="mv4" id="quote1">
            <blockquote className="athelas black-90">
                <p className="f2 code">
                    < Typewriter
                        onInit={(typewriter) => {
                            typewriter
                                .typeString("Hi, I am Aditya Babar. Iam a programmer.")
                                .deleteChars(11)
                                .typeString("developer. ")
                                .start();
                        }} />
                </p>
            </blockquote>
        </div>
    )
}

export default Quote;
